import { Component, OnInit } from '@angular/core';
import { UploadService } from './../../services/upload/upload.service';
import {AlertsService} from '@core/services/alerts/alerts.service';
import { PeopleService } from '@core/state/people/people.service';
import { Person } from '@core/state/people/person.model';
import {CommonToastsService} from '@core/services/common-toasts/common-toasts.service';
import {ActivatedRoute, Router} from '@angular/router';
import { AlertController, NavController } from '@ionic/angular';
import {Subscription} from 'rxjs';
import {ApiService} from '@core/services/api/api.service';
import { paramCase } from 'change-case';

@Component({
  selector: 'app-timpaan-component',
  templateUrl: './timpaan-component.component.html',
  styleUrls: ['./timpaan-component.component.scss'],
})
export class ProjectComponentComponent implements OnInit {
  private subs = new Subscription();

  paramData: any;

  projectId;
  companyId;

  constructor(
    public uploadFile: UploadService,
    private alerts: AlertsService,
    public peopleService: PeopleService,
    private commonToasts: CommonToastsService,
    private router: Router,
    private route: ActivatedRoute,
    private alertCtrl: AlertController,
    public api: ApiService,
    private navCtrl: NavController,
  ) {
    this.route.queryParams.subscribe(params => {
      console.log('params: ', params);
      if (params && params.project && params.company) {
        if (this.intValidator(params.project) && this.intValidator(params.company)) {
          this.paramData = params;
          this.projectId = params.project;
          this.companyId = params.company;
        }
      }
    });
   }

   intValidator(value) {
     return !isNaN(value) && parseInt(value) == value && !isNaN(parseInt(value, 10));
   }

  ngOnInit() {
    if (this.paramData == null) {
      this.navCtrl.navigateBack('/login');
    }
    this.alerts.showLoadingMessage('Laden');
    this.subs.add(
      this.api.get(`project-info/${this.projectId}`).subscribe((result: any) => {

        this.projectName = result.project_name;
        this.projectDescription = result.project_description;
        this.projectImageUrl = result.image_url;
        this.objectName = result.object_name;
        this.objectValue = result.object_value;
        this.objectImageUrl = result.object_image_url;

        this.projectAvailable = result.available;
        this.alerts.dismissLoading();
        })
    );
    this.peopleService.get('self').subscribe((result: any) => {
      this.person = result.data;
      this.userId = result.data.user.id;
      this.PrepareProgressData(result.data.user.id);
      this.alerts.dismissLoading();
    });
  }

  public person: Person = {} as Person;

  userId = 0;
  has_File = true;

  maxPage = 7;

  step = 0;
  maritalStatus = 0;
  marriedBefore = "";

  salary = 0;
  thirteenthMonth = false;
  holidayPay = false;
  partnerAlimonyReceive = 0;
  partnerAlimony = 0;
  personalLoan = 0;
  studentDebt = 0;
  studentDebtType = "false";

  partnerSalary = 0;
  partnerThirteenthMonth = false;
  partnerHolidayPay = false;
  partnerPersonalLoan = 0;
  partnerStudentDebt = 0;
  partnerStudentDebtType = "false";

  marketValue = 0;
  duration = 30;
  interest = 5;
  energyEfficientHome = "0";
  energySavingFacilities = 0;

  //TODO: ADD IT TO DB MIGRATION
  selfPayment = false;
  amountSelfPayment = 0;
  houseValue = false;
  amountHouseValue = 0;
  //TODO END

  costOfLivingItems = [];

  personalLoanPercentage = 2;
  studentDebtOldPercentage = 0.75;
  studentDebtNewPercentage = 0.45;
  studentDebtPercentage = 0.00;

  partnerStudentDebtPercentage = 0.00;

  energySavings = {
    energyLabel: 9000,
    zeroEnergy: 15000,
    zeroEnergyGuarantee: 25000
  };

  //project info
  projectName = "placeholder project name";
  projectDescription = "Placeholder project description";
  projectAvailable = false;
  projectImageUrl = "";

  //object info
  objectName = "placeholder object name";
  objectValue = 9.99;
  objectImageUrl = "";


  formData = new FormData();

  goToBelastingdienst() {
    window.open('https://mijn.belastingdienst.nl/VIADownload2021/index.html', '_blank');
  }

  async viaUpload() {
    return this.uploadFileFromBrowser();
  }

  async uploadFileFromBrowser() {
    let file = await this.uploadFile.browseFileFromBrowser();

    this.formData.append('file', file as Blob);
    if (!file) {
      console.log("No File");
      this.has_File = false;
    }
    else if (file) {
      console.log(file);
      this.has_File = true;
    }
  }

  SendData() {

    this.alerts.showLoadingMessage('Uploading');

    this.peopleService.uploadVia(this.person.id, this.formData)
    .subscribe(result => {
      this.doRefresh();
      this.commonToasts.success('Upload VIA Successful!')
    }, err => {
      this.doRefresh();
      this.presentAlertAndGoToOverview('Upload failed')
    });
  }

  doRefresh() {
    this.peopleService.get('self').subscribe((result: any) => {
      this.alerts.dismissLoading();
    });
  }

  async presentAlertAndGoToOverview(message: string) {
    const alert = await this.alertCtrl.create({
      subHeader: message,
      buttons: [
        {
          text: 'OK',
          role: 'OK',
          handler: data => {
            alert.dismiss();
            this.router.navigateByUrl('/dashboard/overview');
          }
        }
      ]
    });
    alert.present();
  }

  nextpage(pageIndex) {

    if (this.step >= 2) {
      let progressData;

      if (String(this.maritalStatus) == "1") {
        progressData = {
          projectId: this.projectId,
          companyId: this.companyId,
          userId: this.userId,
          step: this.step,
          maritalStatus: this.maritalStatus,
          marriedBefore: this.marriedBefore,
  
          //income
          salary: this.salary,
          thirteenthMonth: this.thirteenthMonth,
          holidayPay: this.holidayPay,
          personalLoan: this.personalLoan,
          studentDebt: this.studentDebt,
          studentDebtType: this.studentDebtType,
  
          //partner information
          partnerSalary : 0,
          partnerThirteenthMonth : 0,
          partnerHolidayPay : 0,
          partnerPersonalLoan : 0,
          partnerStudentDebt : 0,
          partnerStudentDebtType : 0,
  
          //partner alimony
          partnerAlimonyReceive: 0,
          partnerAlimony: 0,
  
          //marketvalue
          marketValue: this.marketValue,
          duration: this.duration,
          interest: this.interest,
  
          //energy
          energyEfficientHome: this.energyEfficientHome,
          energySavingFacilities: this.energySavingFacilities,

          //selfPayment
          selfPayment: this.selfPayment,
          amountSelfPayment: this.amountSelfPayment,
          houseValue: this.houseValue,
          amountHouseValue: this.amountHouseValue,

          //student debt percentage
          studentDebtPercentage: this.studentDebtPercentage,
          partnerStudentDebtPercentage: this.partnerStudentDebtPercentage
        }
      }
      else
      {
        progressData = {
          projectId: this.projectId,
          companyId: this.companyId,
          userId: this.userId,
          step: this.step,
          maritalStatus: this.maritalStatus,
          marriedBefore: this.marriedBefore,
  
          //income
          salary: this.salary,
          thirteenthMonth: this.thirteenthMonth,
          holidayPay: this.holidayPay,
          personalLoan: this.personalLoan,
          studentDebt: this.studentDebt,
          studentDebtType: this.studentDebtType,
  
          //partner information
          partnerSalary : this.partnerSalary,
          partnerThirteenthMonth : this.partnerThirteenthMonth,
          partnerHolidayPay : this.partnerHolidayPay,
          partnerPersonalLoan : this.partnerPersonalLoan,
          partnerStudentDebt : this.partnerStudentDebt,
          partnerStudentDebtType : this.partnerStudentDebtType,
  
          //partner alimony
          partnerAlimonyReceive: this.partnerAlimonyReceive,
          partnerAlimony: this.partnerAlimony,
  
          //marketvalue
          marketValue: this.marketValue,
          duration: this.duration,
          interest: this.interest,
  
          //energy
          energyEfficientHome: this.energyEfficientHome,
          energySavingFacilities: this.energySavingFacilities,

          //selfPayment
          selfPayment: this.selfPayment,
          amountSelfPayment: this.amountSelfPayment,
          houseValue: this.houseValue,
          amountHouseValue: this.amountHouseValue,

          //student debt percentage
          studentDebtPercentage: this.studentDebtPercentage,
          partnerStudentDebtPercentage: this.partnerStudentDebtPercentage
        }
      }
      this.alerts.showLoadingMessage('Laden');
      this.subs.add(
        this.api.post('max-mortgage-progress/store', progressData).subscribe(response => {
          this.alerts.dismissLoading();
          })
      );
    }

    if (this.step == 3 && this.marriedBefore == "false") {      
      this.step = pageIndex + 2;
      console.log("=========================================");
      console.log("Skipping partnerAlimony");
      console.log("===============  " + this.step + "/" + this.maxPage + "  =======================");
    }
    else {
      this.step = pageIndex + 1;
      console.log("===============  " + this.step + "/" + this.maxPage + "  =======================");
    }
  }

  PrepareProgressData(id) {
    let loadprogressData = {
      userId: id,
    }

    this.subs.add(
      this.api.post('max-mortgage-progress/show', loadprogressData).subscribe((result: any) => {

        this.step = result.step;
        this.maritalStatus = result.marital_status;
        this.marriedBefore = result.married_before;

        //income
        this.salary = result.salary;
        this.thirteenthMonth = Boolean(result.thirteenth_month);
        this.holidayPay = Boolean(result.holidaypay);
        this.personalLoan = result.personal_loan;
        this.studentDebt = result.student_debt;
        if (this.studentDebtType == null) {
          this.studentDebtType = "";
        }
        else {
          this.studentDebtType = result.student_debt_type;
        }

        //partner income
        this.partnerSalary = result.partner_salary;
        this.partnerThirteenthMonth = Boolean(result.partner_thirteenth_month);
        this.partnerHolidayPay = Boolean(result.partner_holiday_pay);
        this.partnerPersonalLoan = result.partner_personal_loan;
        this.partnerStudentDebt = result.partner_student_debt;
        if (this.partnerStudentDebtType == null) {
          this.partnerStudentDebtType = "";
        }
        else {
          this.partnerStudentDebtType = result.partner_student_debt_type;
        }

        //partner alimony
        this.partnerAlimonyReceive = result.partner_alimony_receive;
        this.partnerAlimony = result.partner_alimony;

        //market value
        this.marketValue = result.market_value;
        this.duration = result.duration;
        this.interest = result.interest;

        //energy
        this.energyEfficientHome = result.energy_efficient_home;
        this.energySavingFacilities = result.energy_saving_facilities;

        //selfpayment
        this.selfPayment = Boolean(result.self_payment);
        this.amountSelfPayment = result.amount_self_payment;
        this.houseValue = Boolean(result.house_value);
        this.amountHouseValue = result.amount_house_value;

        //student debt percentage
        this.studentDebtPercentage = result.student_debt_percentage;
        this.partnerStudentDebtPercentage = result.partner_student_debt_percentage;
      })
    );
  }

  previousPage(pageIndex) {

    if (this.step == 5 && this.marriedBefore == "false") {      
      this.step = pageIndex - 2;
      console.log("=========================================");
      console.log("Skipping partnerAlimony");
      console.log("===============  " + this.step + "/" + this.maxPage + "  =======================");
      console.log("maritalStatus: " + this.maritalStatus);
      console.log("marriedBefore: " + this.marriedBefore);
      console.log("salary: " + this.salary);
      console.log("thirteenthMonth: " + this.thirteenthMonth);
      console.log("holidayPay: " + this.holidayPay);
      console.log("partnerAlimonyReceive: " + this.partnerAlimonyReceive);
      console.log("partnerAlimony: " + this.partnerAlimony);
      console.log("personalLoan: " + this.personalLoan);
      console.log("studentDebt: " + this.studentDebt);
      console.log("studentDebtType: " + this.studentDebtType);
      console.log("marketValue: " + this.marketValue);
      console.log("duration: " + this.duration);
      console.log("interest: " + this.interest);
      console.log("energyEfficientHome: " + this.energyEfficientHome);
      console.log("energySavingFacilities: " + this.energySavingFacilities);
      console.log("costOfLivingItems: " + this.costOfLivingItems);
      
    }
    else {
      this.step = pageIndex - 1;
      console.log("===============  " + this.step + "/" + this.maxPage + "  =======================");
      console.log("maritalStatus: " + this.maritalStatus);
      console.log("marriedBefore: " + this.marriedBefore);
      console.log("salary: " + this.salary);      
      console.log("thirteenthMonth: " + this.thirteenthMonth);
      console.log("holidayPay: " + this.holidayPay);
      console.log("partnerAlimonyReceive: " + this.partnerAlimonyReceive);
      console.log("partnerAlimony: " + this.partnerAlimony);
      console.log("personalLoan: " + this.personalLoan);
      console.log("studentDebt: " + this.studentDebt);
      console.log("studentDebtType: " + this.studentDebtType);
      console.log("marketValue: " + this.marketValue);
      console.log("duration: " + this.duration);
      console.log("interest: " + this.interest);
      console.log("energyEfficientHome: " + this.energyEfficientHome);
      console.log("energySavingFacilities: " + this.energySavingFacilities);
      console.log("costOfLivingItems: " + this.costOfLivingItems);
      
    }

  }

  durationChecker() {
    if (this.duration < 10) {
      this.interest = 5;
    }
  }

  fetchCostOfLiving() {
    let data = {
      type: 'DEFAULT',
      interest: this.interest
    };

    this.subs.add(
      this.api.post('calculation/cost-of-living-percentages', data).subscribe(response => {
        this.costOfLivingItems = response;})
    );
  }
  
  thirteenthMonthAmount() {
    if (this.thirteenthMonth == false) {
      return 0;
    }

    return this.salary / 12;
  }

  holidayAmount() {
    if (this.holidayPay == false) {
      return 0;
    }

    return (this.thirteenthMonthAmount() + this.salary) * 0.08;
  }

  income() {
    return this.thirteenthMonthAmount() + this.holidayAmount() + this.salary + this.partnerAlimonyReceive;
  }

  partnerThirteenthMonthAmount() {
    if (this.partnerThirteenthMonth == false) {
      return 0;
    }

    return this.partnerSalary / 12;
  }

  partnerHolidayAmount() {
    if (this.partnerHolidayPay == false) {
      return 0;
    }

    return (this.partnerThirteenthMonthAmount() + this.partnerSalary) * 0.08;
  }

  //FIX IT RETURNS NAN HERE!
  partnerIncome() {
    
    if (this.partnerSalary == 0) {
      return 0;
    }
    return this.partnerThirteenthMonthAmount() + this.partnerHolidayAmount() + this.partnerSalary;
  }

  totalIncome() {
    return this.income() + this.partnerIncome();
  }

  formatNumber(value) {
    let number = parseFloat(value);
    let options = { minimumFractionDigits: 2, style: 'currency', currency: 'EUR' };
    return number.toLocaleString("nl-NL", options);
  }

  personalLoanAmount() {
    if (this.personalLoan == 0) {
      return 0;
    }

    return this.personalLoan * (this.personalLoanPercentage / 100);
  }

  partnerPersonalLoanAmount() {
    if (this.partnerPersonalLoan == 0) {
      return 0;
    }

    return this.partnerPersonalLoan * (this.personalLoanPercentage / 100);
  }

  studentDebtTypeCheck() {

    if (this.studentDebtType == "old") {
      this.studentDebtPercentage = this.studentDebtOldPercentage;
    }
    else if (this.studentDebtType == "new") {
      this.studentDebtPercentage = this.studentDebtNewPercentage;
    }
    else if (this.studentDebtType == "false") {
      this.studentDebtPercentage = 0.00;
    }

  }

  partnerStudentDebtTypeCheck() {

    if (this.partnerStudentDebtType == "old") {
      this.partnerStudentDebtPercentage = this.studentDebtOldPercentage;
    }
    else if (this.partnerStudentDebtType == "new") {
      this.partnerStudentDebtPercentage = this.studentDebtNewPercentage;
    }
    else if (this.partnerStudentDebtType == "false") {
      this.partnerStudentDebtPercentage = 0.00;
    }

  }

  studentDebtAmount() {
    if (this.studentDebt == 0) {
      return 0;
    }

    return this.studentDebt * (this.studentDebtPercentage / 100);
  }

  partnerStudentDebtAmount() {
    if (this.partnerStudentDebt == 0) {
      return 0;
    }

    return this.partnerStudentDebt * (this.partnerStudentDebtPercentage / 100);
  }

  expenses() {
    return this.partnerAlimony;
  }

  energyBenefit() {
    if (this.energyEfficientHome === "0") {
      return 0;
    }

    if (this.energySavings[this.energyEfficientHome] <= this.energySavingFacilities) {
      return this.energySavings[this.energyEfficientHome];
    }

    return this.energySavingFacilities;
  }

  grossIncome() {
    return this.totalIncome() - this.expenses();
  }

  maxLivingCostPerMonth() {
    if (! this.grossIncome()) {
      return 0;
    }

    return (this.grossIncome() * (this.costOfLivingPercentage() / 100) / 12) - this.expensesPerMonth();
  }

  costOfLivingPercentage() {
    if (this.costOfLivingItems.length <= 0) {
      return 0;
    }

    let found = this.costOfLivingItems.find(item => {
      return item.income <= this.grossIncome();
    });

    return found.standard * 100;
  }

  expensesPerMonth() {
    return this.personalLoanAmount() + this.studentDebtAmount() + this.partnerPersonalLoanAmount() + this.partnerStudentDebtAmount();
  }

  maxMortgageIncome() {
    if (! this.maxLivingCostPerMonth() && ! this.mortgageInterest()) {
      return 0;
    }

    return this.maxLivingCostPerMonth() / this.mortgageInterest();
  }

  mortgageInterest() {
    let monthInterest = (this.interest / 100) / 12;

    return monthInterest * Math.pow((monthInterest + 1), this.durationInMonths()) / (Math.pow((monthInterest + 1), this.durationInMonths()) - 1);
  }

  durationInMonths() {
    return this.duration * 12;
  }

  maxMortgage() {
    if (! this.maxMortgageIncome()) {
      return 0;
    }

    // Max 106% including energy benefit
    let max = this.maxMortgageIncome() + this.energyBenefit() + this.amountSelfPayment + this.amountHouseValue;
    if (this.marketValue && max > this.marketValue * 1.06) {
      return this.marketValue * 1.06;
    }

    // Max 100% of market value
    if (this.marketValue && this.maxMortgageIncome() > this.marketValue) {
      return this.marketValue;
    }

    return max;
  }

  goToFinopsSite() {
    window.open('https://finopshypotheken.nl/afspraak-maken/', '_blank');
    window.open('https://mijn.belastingdienst.nl/VIADownload2021/index.html', '_blank');
  }

  BackToStart() {
    this.step = 1;

    let progressData

    progressData = {
      userId: this.userId,
      step: 1,
      maritalStatus: this.maritalStatus,
      marriedBefore: this.marriedBefore,

      //income
      salary: this.salary,
      thirteenthMonth: this.thirteenthMonth,
      holidayPay: this.holidayPay,
      personalLoan: this.personalLoan,
      studentDebt: this.studentDebt,
      studentDebtType: this.studentDebtType,

      //partner information
      partnerSalary : 0,
      partnerThirteenthMonth : 0,
      partnerHolidayPay : 0,
      partnerPersonalLoan : 0,
      partnerStudentDebt : 0,
      partnerStudentDebtType : 0,

      //partner alimony
      partnerAlimonyReceive: 0,
      partnerAlimony: 0,

      //marketvalue
      marketValue: this.marketValue,
      duration: this.duration,
      interest: this.interest,

      //energy
      energyEfficientHome: this.energyEfficientHome,
      energySavingFacilities: this.energySavingFacilities,

      //student debt percentage
      studentDebtPercentage: this.studentDebtPercentage,
      partnerStudentDebtPercentage: this.partnerStudentDebtPercentage
    }

    this.alerts.showLoadingMessage('Laden');
    this.subs.add(
      this.api.post('max-mortgage-progress/store', progressData).subscribe(response => {
        this.alerts.dismissLoading();
        })
    );

  }
}
